import React from 'react';
import ReactDOM from 'react-dom';
import { Form as AntForm, Input, Select, Checkbox, Radio, Button, Modal, Icon, Card } from 'antd';
import { Form, Scenario } from 'rx-model';
import {
  PresenceValidator, ObjectValidator, ArrayValidator, NumberValidator,
} from 'rx-model/validators';
import { FormConnect } from 'react-rx-form';

class ComplexDataForm extends Form {
  // правила валидации
  rules() {
    return {
      'name': new PresenceValidator(),
      'personal': new ObjectValidator(),
      'personal.phone': new PresenceValidator(),
      'personal.address': new PresenceValidator(),
      'experience': [
        new PresenceValidator(),
        new ArrayValidator({
          minLength: 1,
        }),
      ],
      'experience[]': new ObjectValidator(),
      'experience[].company': new PresenceValidator(),
      'experience[].period': [
        new PresenceValidator(),
        new NumberValidator(),
      ],
      'experience[].duties': new ArrayValidator(),
      'experience[].duties[]': new PresenceValidator(),
    }
  }

  prepareSourceData(data) {
    return {
      personal: {},
      experience: [],
      ...data,
    };
  }
}

const FormItem = AntForm.Item;

export default class ComplexDataFormComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form: new ComplexDataForm()
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddExperience = this.handleAddExperience.bind(this);
  }

  setAttributeRef(attr, el) {
    this[`attr_${attr}`] = el;
  }

  getAttributeRef(attr) {
    return this[`attr_${attr}`];
  }

  // фокус компонента не прошедшего валидацию
  focus(component) {
    if (component.focus) {
      component.focus();
    } else if (component.getWrappedInstance) {
      component = component.getWrappedInstance();
      this.focus(component);
    } else {
      component = ReactDOM.findDOMNode(component);
      component && component.focus();
    }
  }

  handleSubmit() {
    const { form } = this.state;

    form.validate().then(isValid => {
      if (isValid) {
        const attributes = form.getAttributes();

        Modal.success({
          title: 'Attributes',
          content: <pre>{JSON.stringify(attributes, null, "  ")}</pre>,
        })
      } else {
        const error = form.getFirstError();
        const component = this.getAttributeRef(error.attribute);

        component && this.focus(component);
      }
    })
  }

  handleAddExperience() {
    const { form } = this.state;

    const experience = form.getAttribute('experience');
    experience.push({ duties: [] });

    return form.setAttributeAndValidate('experience', experience);
  }

  handleRemoveExperience(index) {
    const { form } = this.state;

    return form.setAttributeAndValidate('experience', form.getAttribute('experience').filter((item, i) => i !== index));
  }

  render() {
    const { form } = this.state;

    return (
      <AntForm>
        <FormConnect
          form={form}
          whenModel={['name']}
        >{() => {
          return <FormItem
            label={<span><b>name</b></span>}
            validateStatus={form.getValidationStatus('name')}
            help={form.getValidationError('name')}
            required={form.isAttributeRequired('name')}
          >
            <Input
              ref={el => this.setAttributeRef('name', el)}
              value={form.getAttribute('name')}
              onChange={(e) => form.setAttribute('name', e.target.value)}
              onBlur={() => form.validateAttributes(['name'])}
              disabled={!form.isAttributeSafe('name')}
            />
          </FormItem>
        }}</FormConnect>

        <h2>Персональные данные</h2>

        <FormConnect
          form={form}
          whenModel={['personal.phone']}
        >{() => {
          return <FormItem
            label={<span><b>phone</b></span>}
            validateStatus={form.getValidationStatus('personal.phone')}
            help={form.getValidationError('personal.phone')}
            required={form.isAttributeRequired('personal.phone')}
          >
            <Input
              ref={el => this.setAttributeRef('personal.phone', el)}
              value={form.getAttribute('personal.phone')}
              onChange={(e) => form.setAttribute('personal.phone', e.target.value)}
              onBlur={() => form.validateAttributes(['personal.phone'])}
              disabled={!form.isAttributeSafe('personal.phone')}
            />
          </FormItem>
        }}</FormConnect>

        <FormConnect
          form={form}
          whenModel={['personal.address']}
        >{() => {
          return <FormItem
            label={<span><b>address</b></span>}
            validateStatus={form.getValidationStatus('personal.address')}
            help={form.getValidationError('personal.address')}
            required={form.isAttributeRequired('personal.address')}
          >
            <Input
              ref={el => this.setAttributeRef('personal.address', el)}
              value={form.getAttribute('personal.address')}
              onChange={(e) => form.setAttribute('personal.address', e.target.value)}
              onBlur={() => form.validateAttributes(['personal.address'])}
              disabled={!form.isAttributeSafe('personal.address')}
            />
          </FormItem>
        }}</FormConnect>

        <h2>Опыт работы</h2>

        <FormConnect
          form={form}
          whenModel={['experience']}
        >{() => {
          const experience = form.getAttribute('experience');

          return <div className="form-cards">
            {experience.map((item, index) => {
              const attrCompany = `experience[${index}].company`;
              const attrPeriod = `experience[${index}].period`;
              const attrDuties = `experience[${index}].duties`;

              return <Card
                key={`experience_${index}`}
                extra={<a onClick={() => this.handleRemoveExperience(index)}>
                  <Icon type="close" /> Удалить
                </a>}
              >
                <FormConnect
                  form={form}
                  whenModel={[attrCompany]}
                >{() => {
                  return <FormItem
                    label={<span><b>company</b></span>}
                    validateStatus={form.getValidationStatus(attrCompany)}
                    help={form.getValidationError(attrCompany)}
                    required={form.isAttributeRequired(attrCompany)}
                  >
                    <Input
                      ref={el => this.setAttributeRef(attrCompany, el)}
                      value={form.getAttribute(attrCompany)}
                      onChange={(e) => form.setAttribute(attrCompany, e.target.value)}
                      onBlur={() => form.validateAttributes([attrCompany])}
                      disabled={!form.isAttributeSafe(attrCompany)}
                    />
                  </FormItem>
                }}</FormConnect>

                <FormConnect
                  form={form}
                  whenModel={[attrPeriod]}
                >{() => {
                  return <FormItem
                    label={<span><b>period</b></span>}
                    validateStatus={form.getValidationStatus(attrPeriod)}
                    help={form.getValidationError(attrPeriod)}
                    required={form.isAttributeRequired(attrPeriod)}
                  >
                    <Input
                      ref={el => this.setAttributeRef(attrPeriod, el)}
                      value={form.getAttribute(attrPeriod)}
                      onChange={(e) => form.setAttribute(attrPeriod, e.target.value)}
                      onBlur={() => form.validateAttributes([attrPeriod])}
                      disabled={!form.isAttributeSafe(attrPeriod)}
                    />
                  </FormItem>
                }}</FormConnect>

                <FormConnect
                  form={form}
                  whenModel={[attrDuties]}
                >{() => {
                  return <div>
                    <h2>Обязанности (duties)</h2>

                    {form.getAttribute(attrDuties).map((value, index) => {
                      const attr = attrDuties + `[${index}]`;

                      return <FormConnect
                        key={attr}
                        form={form}
                        whenModel={[attr]}
                      >{() => {
                        return <div>
                          <a
                            className="float-right"
                            style={{ position: 'relative', zIndex: 1 }}
                            onClick={() => {
                              const { form } = this.state;

                              return form.setAttributeAndValidate(attrDuties, form.getAttribute(attrDuties).filter((item, i) => i !== index));
                            }}
                          >
                            <Icon type="close" /> Удалить
                          </a>

                          <FormItem
                            label={<span><b># {index+1}</b></span>}
                            validateStatus={form.getValidationStatus(attr)}
                            help={form.getValidationError(attr)}
                            required={form.isAttributeRequired(attr)}
                          >
                            <Input
                              ref={el => this.setAttributeRef(attr, el)}
                              value={form.getAttribute(attr)}
                              onChange={(e) => form.setAttribute(attr, e.target.value)}
                              onBlur={() => form.validateAttributes([attr])}
                              disabled={!form.isAttributeSafe(attr)}
                            />
                          </FormItem>
                        </div>
                      }}</FormConnect>
                    })}

                    <FormItem
                      className="float-right"
                    >
                      <Button
                        size="small"
                        onClick={() => {
                          const duties = form.getAttribute(attrDuties);

                          duties.push('');

                          form.setAttribute(attrDuties, duties);
                        }}
                      >
                        <Icon type="plus" /> Добавить
                      </Button>
                    </FormItem>
                  </div>
                }}</FormConnect>
              </Card>
            })}

            <div className="has-error">
              <div className="ant-form-explain">
                {form.getValidationError('experience')}
              </div>
            </div>
          </div>
        }}</FormConnect>

        <FormItem
          className="float-right"
        >
          <Button
            onClick={this.handleAddExperience}
            size="small"
          >
            <Icon type="plus" /> Добавить
          </Button>
        </FormItem>

        <FormItem className="clear-both">
          <Button onClick={this.handleSubmit}>Submit</Button>
        </FormItem>
      </AntForm>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/forms/ComplexDataForm.js